import * as service from './service'
export default {
  namespace: 'equipmentMallLogisticsList',
  state: {
    queryLogisticsData: {
      logisticsInfoList: [
      ],
      description: ''
    }
  },
  effects: {
    * queryLogistics ({ payload }, { call, put }) {
      const res = yield call(service.queryLogistics, payload)
      if (res.data.status === 200) {
        yield put({
          type: 'save',
          payload: {
            queryLogisticsData: res.data.data
          }
        })
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
